// src/utils/formation.js
// Lecture des traductions avec repli automatique.
//
// Les textes affichés viennent de /locales/{langue}/translation.json servi par le site
// (fichiers modifiables depuis l'ERP : DAJC > Gestionnaire de langues DAJC). Si une clé
// n'existe pas encore dans ces fichiers, la valeur livrée dans src/locales est utilisée :
// aucune clé brute (« formation.title ») ne peut apparaître à l'écran.
import fr from "../locales/fr/translation.json";
import ar from "../locales/ar/translation.json";
import en from "../locales/en/translation.json";

const BUNDLED = { fr, ar, en };

export function normalizeLang(value) {
  const code = String(value || "fr").slice(0, 2).toLowerCase();
  return BUNDLED[code] ? code : "fr";
}

function lookup(source, key) {
  return key.split(".").reduce((value, part) => (value && value[part] !== undefined ? value[part] : undefined), source);
}

/**
 * t(clé) avec repli sur la traduction livrée avec le site.
 *   tf(t, "ar", "formation.title")
 *   tf(t, lang, "formation.shown", { shown: 12, total: 81 })
 */
export function tf(t, lang, key, vars) {
  const code = normalizeLang(lang);
  const bundled = lookup(BUNDLED[code], key);
  const fallback = bundled !== undefined ? bundled : lookup(BUNDLED.fr, key);
  return t(key, { lng: code, defaultValue: fallback !== undefined ? fallback : key, ...vars });
}
